import { getString } from "../../common/uistringlabels/ui-string-utils";
import { Order, OrderItem, HopOrder } from "@/services/orders/orders.types";

export const CANCEL_STRINGS_PATH = "orderCancellation";

export enum OrderStatus {
  NEW = "NEW",
  PROCESSING = "PROCESSING",
  DELIVERED = "DELIVERED",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
  REJECTED = "REJECTED",
}

export enum CancellationReason {
  NO_LONGER_NEEDED = "No longer needed",
  ORDERED_BY_MISTAKE = "Ordered by mistake",
  SWITCHING_TO_DIFFERENT_ASSET = "Switching to a different asset",
  OTHER = "Other",
}

export interface CancellationState {
  isLoading: boolean;
  error: string | null;
}

export interface OrderDetails {
  orderId: string;
  orderReference: string;
  assetName: string;
  requestDate: string;
}

const NON_CANCELLABLE_STATUSES: string[] = ["SHIPPED", "DELIVERED", "CANCELLED", "COMPLETED"];
const HOP_CANCELLABLE_STATUS = "ready-for-export";

export function isCancellableStatus(status?: string): boolean {
  if (!status) return false;
  return !NON_CANCELLABLE_STATUSES.includes(status.toUpperCase());
}

export function isHopCancellable(items?: OrderItem[]): boolean {
  if (!items || items.length === 0) return true;
  const allHopOrders = items.flatMap((item) => item.details?.hopOrders ?? []);
  if (allHopOrders.length === 0) return true;
  return allHopOrders.every((hop: HopOrder) => !hop.status || hop.status === HOP_CANCELLABLE_STATUS);
}

const HIDDEN_CANCEL_STATUSES: string[] = [OrderStatus.CANCELLED, OrderStatus.REJECTED];

export function shouldHideCancelButton(status?: string): boolean {
  return HIDDEN_CANCEL_STATUSES.includes(status?.toUpperCase() ?? "");
}

export function extractOrderDetails(order: Order): OrderDetails {
  const firstItem = order.items?.[0];
  const assetName =
    firstItem?.itemInformation?.name ?? getString(`${CANCEL_STRINGS_PATH}.unknownAssetName`);
  return {
    orderId: order.orderId ?? "",
    orderReference: order.orderReference ?? "",
    assetName,
    requestDate: order.requested?.on
      ? new Date(order.requested.on).toLocaleDateString()
      : getString(`${CANCEL_STRINGS_PATH}.unknownRequestDate`),
  };
}
